import { render } from "./HomeServices.vue?vue&type=template&id=0cde2fa1&scoped=true&ts=true"
import script from "./HomeServices.vue?vue&type=script&lang=ts"
export * from "./HomeServices.vue?vue&type=script&lang=ts"

import "./HomeServices.vue?vue&type=style&index=0&id=0cde2fa1&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cde2fa1"]])

export default __exports__